module.exports = __webpack_public_path__ + "static/media/VinNumber.766a3697.svg";